import { ReactComponent as facebook } from "../../assets/facebook-svg.svg";
import { ReactComponent as reddit } from "../../assets/reddit-svg.svg";
import { ReactComponent as telegram } from "../../assets/telegram-svg.svg";
import { ReactComponent as whatsapp } from "../../assets/whatsapp-svg.svg";
import { ReactComponent as worldWideWeb } from "../../assets/world-wide-web-svg.svg";
import { ReactComponent as twitter } from "../../assets/twitter-icon.svg";
import { ReactComponent as medium } from "../../assets/medium-icon.svg";
import { SocialMediaEnum } from "../../store/crypto/models/internal";

export const socialIconMap: Record<typeof SocialMediaEnum.T, typeof reddit> = {
    WHATSAPP: whatsapp,
    WEBSITE: worldWideWeb,
    FACEBOOK: facebook,
    REDDIT: reddit,
    TELEGRAM: telegram,
    MEDIUM: medium,
    TWITTER: twitter,
  };
  